import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Controller } from "react-hook-form";
import API from "src/services/api";

const SwipetypeForm = ({
  id,
  control,
  errors,
  label,
  labelLeft,
  labelRight,
  helperText,
  disabled,
  size,
  multiple = false,
  inline = false,
}) => {
  const hasError = errors[id] !== undefined;

  const [items, setItems] = useState([
    { id: "", name: "Daten werden geladen...", disabled: true },
  ]);

  const loadItems = async () => {
    const data = await API.getSwipetypes();
    if (data.status === true) {
      setItems([{ id: "", name: "Bitte wählen" }, ...data.data]);
    } else {
      setItems([{ id: "", name: "No data", disabled: true }]);
    }
  };

  useEffect(() => {
    loadItems();
  }, []);

  return (
    <Form.Group controlId={id} style={{ marginBottom: "1rem" }}>
      {label && <Form.Label>{label}</Form.Label>}
      <InputGroup size={size}>
        {labelLeft && (
          <InputGroup.Prepend>
            <InputGroup.Text>{labelLeft}</InputGroup.Text>
          </InputGroup.Prepend>
        )}

        {!multiple && (
          <Controller
            name={id}
            control={control}
            render={({ field }) => (
              <select
                id={id}
                className={[
                  "form-select",
                  size ? `form-select-${size}` : "",
                  hasError ? "is-invalid" : "",
                ].join(" ")}
                readOnly={disabled}
                {...field}
                // onChange={onChange}
                disabled={disabled}
              >
                {items.map((i) => (
                  <option key={`${id}-${i.id}`} value={i.id}>
                    {i.name}
                  </option>
                ))}
              </select>
            )}
          />
        )}

        {multiple &&
          items.map((i) => (
            <Controller
              name={i.id}
              control={control}
              render={({ field }) => (
                <div
                  className={[
                    "form-check",
                    inline ? "form-check-inline" : "",
                  ].join(" ")}
                  key={`${id}-${i.id}`}
                >
                  <React.Fragment>
                    <input
                      readOnly={disabled}
                      {...field}
                      // onChange={onChange}
                      disabled={disabled}
                      id={`${id}-${i.id}`}
                      className="form-check-input"
                      type="checkbox"
                    />{" "}
                    <label
                      title=""
                      htmlFor={`${id}-${i.id}`}
                      className="form-check-label"
                    >
                      {i.name}
                    </label>
                  </React.Fragment>
                </div>
              )}
            />
          ))}
        {labelRight && (
          <InputGroup.Append>
            <InputGroup.Text>{labelRight}</InputGroup.Text>
          </InputGroup.Append>
        )}
      </InputGroup>
      {hasError && (
        <div className="invalid-feedback" style={{ display: "block" }}>
          {errors[id].message}
        </div>
      )}
      {helperText && <Form.Text muted>{helperText}</Form.Text>}
    </Form.Group>
  );
};

SwipetypeForm.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ).isRequired,
  control: PropTypes.object.isRequired,
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
  label: PropTypes.string,
  labelLeft: PropTypes.string,
  labelRight: PropTypes.string,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.string,
  onChange: PropTypes.func,
};

SwipetypeForm.defaultProps = {
  label: "",
  labelLeft: "",
  labelRight: "",
  helperText: "",
  disabled: false,
  size: "",
  onChange: null,
};

export default SwipetypeForm;
